module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-04.8f301016.jpg";